<template>
    <div class="menu-field">
        <div class="menu-inner-field">
            <div class="mobile-menu-left-side">
                <EonOutlinedIconButton
                    icon="pi pi-bars"
                    class="mobile-submenu-button"
                    @click="toggleMenu($event)"
                    aria-label="Otwórz menu"
                    retain-focus-on-click
                />
                <PrimeMenu
                    :model="leftItems[0].items"
                    style="border: none;"
                    popup
                    ref="menu"
                >
                </PrimeMenu>
            </div>
            <div class="menu-right-side">
                <a class="skip-link screen-reader-text" href="#content">Przejdź do treści</a>
                <div class="logo-container logo">
                    <a href="https://stoen.pl/">
                        <img class="logo" src="../../assets/logoStoenRed.svg"
                             alt="Przejście na stronę główną stoen.pl" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Menu from "primevue/menu";
    import TabMenu from "primevue/tabmenu";
    import {SystemRole} from "@/utils/SystemRole";
    import EonOutlinedIconButton from "@/components/form/EonOutlinedIconButton";

    export default {
        name: "EonTabMenuMobile",
        components: {
            EonOutlinedIconButton,
            TabMenu,
            PrimeMenu: Menu,
        },

        data() {
            return {
                showSidebar: false,
                show: false,
                activeIndex: null,
            };
        },

        props: {
            leftItems: {
                type: Array,
            },
            rightItems: {
                type: Array,
            },
            isUserLoggedIn: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            handleItemClick(item) {
                this.$emit("handle-item-click", item);
            },
            showLoginButton() {
                return SystemRole.getUserRole() === null && !SystemRole.isPublic();
            },
            toggleLoginSidebar() {
                this.$emit("toggle-login-sidebar");
            },
            toggleMenu(e) {
                this.$refs.menu.toggle(e);
            },
            onTabChange(e) {
                this.activeIndex = e.index;
                if (e.index === 0) {
                    this.$refs.nestedMenu.toggle(e.originalEvent);
                } else {
                    this.$refs.nestedMenu.hide();
                }
            },
        },
    };

</script>
<style lang="less">
@import "../assets/less/tabmenu.less";
</style>
<style scoped>
.menu-field {
    height: 3.75em;
    position: fixed;
    border-top: 4px solid #E8E8E8;
    border-bottom: none;
    bottom: 0;
}
.logo {
    height: 4em;
    padding-right: 1em;
    padding-left: 1em;
    padding-bottom: 0.5em;
}
.logo-container {
    display: flex;
    align-items: center;
    padding: 0;
    margin-left: 1em;
}

:deep(.pi) {
    font-size: 1.2em;
}

.mobile-menu-left-side {
    display: flex;
    flex: 1;
    padding: 2px 4px 0 4px;
}

:deep(.button-icon) {
    transform: translateY(15%);
}

.submenu {
    left: 50%;
    transform: translateX(-65%);
    position: absolute;
    width: 150px;
    top: 100%;
    background-color: white;
    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    z-index: 1000;
    margin-top: 5px;
    padding-bottom: 8px;
}
.submenu::before {
    content: '';
    position: absolute;
    top: 12px;
    width: 0;
    height: 0;
    box-sizing: border-box;
    border: 10px solid black;
    border-color: transparent transparent white white;
    transform-origin: 0 0;
    box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.4);
    transform: rotate(135deg) translateX(-75%);
}

.submenu::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 6px;
    background-color: #0075c2;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.submenu a {
    display: block;
    padding: 10px;
    text-decoration: none;
    color: black;
    border-radius: 8px;
    transition: background-color 0.3s ease;
}

.submenu a:hover {
    background-color: #f0f0f0;
}

.menu-item {
    height: 100%;
}

.screen-reader-text {
    position: absolute;
    left: -9999px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
    display: flex;
    align-items: center;
}

.screen-reader-text:focus,
.screen-reader-text:active {
    /* position: static; */
    width: auto;
    height: auto;
    padding: 10px 15px;
    margin: 10px;
    background: #EA1B0A;
    color: #fff;
    text-decoration: none;
    border-radius: 4px;
    z-index: 10000;
    border: none;
    left: unset;
}
</style>
